module.exports = __webpack_public_path__ + "static/media/img_inputTextIos.5fa71269.png";